import { canv } from "@/canv/global.js";
import type { ExtendsOfElementBase } from "@/canvasController/types";
import { Group } from "@/group";
import { selectionManager } from "@/tools/cursorTool";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";
import styles from "./wm_lock.module.css";

export class WmLock extends wmBase {
    constructor(options: widgetOption[]) {
        super();
        this.options = options;
    }

    build() {
        let selected = "";
        this.mode = false;

        if (
            canv.canvasController.selected.length !== 0 &&
            canv.canvasController.selected[0].isLocked === true
        ) {
            selected = styles.wm_lock_selected;
            this.mode = true;
        }

        return `
            <div class="${styles.wm_lock} ${selected}">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-3CqDw icon_large-2wsCL" aria-hidden="true" data-testid="svg-icon" focusable="false" role="presentation"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 5a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4v4a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h8V5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2 1 1 0 0 1-2 0Zm0 6a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1H7Z" fill="currentColor"></path></svg>
            </div>
        `;
    }

    init() {
        const item = document.querySelector<HTMLDivElement>(`.${styles.wm_lock}`);
        item?.removeEventListener("click", this.itemClick, false);
        item?.addEventListener("click", this.itemClick, false);
    }

    lockElementAndDescendants = (element: Group | ExtendsOfElementBase, mode: boolean) => {
        if (element instanceof Group) {
            element.fixState("lock");
            element.isLocked = mode;
            element.saveState();

            if (element.children && element.children.length > 0) {
                if (Array.isArray(element.children)) {
                    element.children.forEach((child) => {
                        // TODO: проверить поправить типы
                        // elementBase и ExtendsOfElementBase - это про одно и то же?
                        this.lockElementAndDescendants(
                            child as unknown as Group | ExtendsOfElementBase,
                            mode,
                        );
                    });
                }
            }
        }
    };

    itemClick = (e: Event) => {
        const otherSubm = document.querySelector(".widgetSubMenu");
        if (otherSubm) {
            otherSubm.outerHTML = "";
        }

        const selected = canv.canvasController.selected;
        if (!selected.length) {
            return;
        }

        canv.eventManager.openRecord();
        if (this.mode) {
            // unlock selected
            // выбрана заблокированная группа, мы ее хотим разблокировать
            // мы тут ориентируемся на то, что выбрана может быть только одна залоченая группа
            // и не может быть 2 и более выделенных групп, которые все залочены или частично залочены
            // (мы можем выделить мышкой одну залоченую группу, но не более)
            if (selected.length !== 1) {
                console.log(
                    "такого быть не должно - выделено больше 1 группы, когда одна из них залочена",
                );
                return;
            }
            const selectedGroup = selected[0];

            this.lockElementAndDescendants(selectedGroup, false);

            if (selectedGroup.parent) {
                // если мы выбрали элемент внутри группы и хотим его разлочить - нужно вначале разгруппировать
                // при выделении залоченой группы у нас выделяется группа и у нее есть parent - lock группа
                canv.canvasController.TryUngroup(selectedGroup.parent);
            } else {
                const childGroups = [...selectedGroup.children];

                for (let i = 0; i < childGroups.length; i++) {
                    childGroups[i].fixState("parentUID");
                    childGroups[i].setParent(null);
                    childGroups[i].saveState();
                }

                selectedGroup.children = [];

                canv.eventManager.createBuildEvent("delete", selectedGroup);

                canv.canvasController.groups.delete(selectedGroup.UID);
                selectionManager.setSelected(childGroups as Group[]);
            }

            this.mode = false;
        } else {
            // lock selected
            // выбраны не заблокированные группы/группа, мы хотим ее заблокировать
            // если выделена одна или несколько групп - создаем новую группу и лочим ее
            const [newGroup] = canv.canvasController.TryGroup(
                selected,
                true,
                selected.length === 1 ? selected[0].indexByParent : null,
            );
            this.lockElementAndDescendants(newGroup, true);
            this.mode = true;
            selectionManager.setSelected([newGroup]);
        }
        canv.eventManager.closeRecord();

        const menuItem = e.currentTarget;
        if (menuItem instanceof HTMLElement) {
            menuItem.classList.toggle(styles.wm_lock_selected, this.mode);
        }
        // закрываем меню, чтобы обновить (при lock/unlock), самый дешевый способ и быстро работающий
        canv.widgetMenu.hide();
    };

    mode = false;
    options: widgetOption[] = [];
}
